import * as React from 'react';
import {CONTENT_TYPE} from '../../Config/appConfig';
import AppContainer from './AppContainer';

class CreateContainer extends React.Component <{}, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.CREATE}/>
        );
    }
}

export default CreateContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/CreateContainer.tsx